module.exports = __webpack_public_path__ + "img/C08TechSpearmanChampion_ua.92f7b640.webp";